export default __webpack_public_path__ + "static/SRF 4270LV - Product Specifications & Technical Data-3baa5c8d33198ebfe062cc0209f69a53.pdf";